import React from 'react';
import Resources from '../pages/Resources';

const WorkingMethod = () => {
  const iframeStyle = {
    margin: '20px', // Adjust the margin as needed
    // Adjust the padding as needed
    borderRadius: '8px', // Adjust the border radius as needed

  };

  return (
    <div>
      <Resources />
      <div style={{ marginLeft: '300px' }}>
        <iframe
          width="560"
          height="400"
          src="https://www.youtube.com/embed/PmtO7-fMs1o?si=8KLGOmFatqscC7gC"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={iframeStyle} // Apply the style to the iframe
        ></iframe>

        <iframe
          width="560"
          height="400"
          src="https://www.youtube.com/embed/19LnakglS_4?si=RQdLBNlHW6EFMX__"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={iframeStyle} // Apply the style to the iframe
        ></iframe>

        <br />
        <br />

        <iframe
          width="560"
          height="400"
          src="https://www.youtube.com/embed/ogomFEIUxEk?si=lVXKbEOo7Z8gPHm4"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={iframeStyle} // Apply the style to the iframe
        ></iframe>
      </div>
    </div>
  );
};

export default WorkingMethod;
